import React from "react";
import SocialTemp from "./SocialTemp/SocialTemp";
import { socialHandlesObject } from "../../../assets/text/socialIText";

const socialHandle = () => {
  const handles = socialHandlesObject.map((handle, index) => {
    return <SocialTemp key={index} logo={handle.logo} link={handle.link} />;
  });
  return <>{handles}</>;
};

export default socialHandle;
